import React from "react";
import StockLedgerService from "services/stock-ledger";

import { connect } from "react-redux";
import { loadLedger } from "reducers/stock";

class StockLedger extends React.Component {
  stockLedgerService = new StockLedgerService();

  constructor() {
    super(...arguments);
    this.load();
  }

  async load() {
    await this.stockLedgerService
      .getAll()
      .then(({ data }) => this.props.loadLedger(data));
  }

  render() {
    return null;
  }
}

export default connect(null, { loadLedger })(StockLedger);
